import { useAppSelector } from '../../hooks/redux'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import {
    SetPhoneInitialValues,
    SetPhoneOnsubmit,
    SetPhoneValidate
} from '../../FormTypes/FSetPhone'
import { Strings } from '../../constants/Strings'
import style from './Form.module.css'
import GoButton from '../buttons/GoButton'

interface Props {
    initialValues: SetPhoneInitialValues
    validate: SetPhoneValidate
    onSubmit: SetPhoneOnsubmit
}

const SendPhoneForm = ({
        initialValues,
        validate,
        onSubmit
    }: Props
) => {

    const language = useAppSelector<string>(state => state.language.language)

    return (
        <Formik
            initialValues={initialValues}
            validate={validate}
            onSubmit={onSubmit}
            >
            {({ errors, isSubmitting, values }) => (
                <Form className={style.form} >

                    <ErrorMessage
                        className={style.err}
                        name="phone"
                        component="div"
                    />
                    <Field
                        className={style.codeRegion}
                        name="code"
                        as="select"
                    >
                        <option defaultChecked value="+993">+993 Türkmenistan</option>
                        <option value="+90">+90 Türkiýe</option>
                        <option value="+7">+7 Россия</option>
                    </Field>

                    <Field
                        className={style.phone}
                        type="tel"
                        name="phone"
                        autoComplete="current-phone"
                        placeholder={Strings[language ?? 'tm'].phonePlace}
                        pattern="[0-9]{8,10}"
                        title={Strings[language ?? 'tm'].pattern + ': ' + Strings[language ?? 'tm'].numbers + ' (0-9).'}
                    />

                    <GoButton
                        title={Strings[language ?? 'tm'].send}
                        type={"submit"}
                        disabled={isSubmitting}
                        left={false}
                        right={false}
                    />
                </Form>
            )}
        </Formik>
    )
}

export default SendPhoneForm